module.exports = __webpack_public_path__ + "img/Group_26999.fcfd8943.svg";